// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfileDropdown-cls1_5jC","cls2":"ProfileDropdown-cls2_HiC ProfileDropdown-cls1_5jC"};